import { render } from "./Editor.vue?vue&type=template&id=ef1c7ccc&scoped=true"
import script from "./Editor.vue?vue&type=script&lang=js"
export * from "./Editor.vue?vue&type=script&lang=js"

import "./Editor.vue?vue&type=style&index=0&id=ef1c7ccc&lang=less&scoped=true"

import exportComponent from "D:\\hym\\WEB\\交接项目\\盘古信息客户应用案例\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ef1c7ccc"]])

export default __exports__